import React, { useState } from 'react';
import { FaTimes, FaSearch, FaCheck } from 'react-icons/fa';

const CoursePickerModal = ({ courses, onSelect, onClose }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCourses, setSelectedCourses] = useState([]);

  const filteredCourses = courses.filter(course =>
    course.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const toggleCourse = (course) => {
    setSelectedCourses(prev =>
      prev.includes(course) 
        ? prev.filter(c => c._id !== course._id)
        : [...prev, course]
    );
  };

  const handleSubmit = () => {
    onSelect(selectedCourses);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[90vh] flex flex-col">
        <div className="flex items-center justify-between p-4 border-b border-[#1086a4]">
          <h2 className="text-lg font-semibold text-[#054581]">Add Courses</h2>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-400 hover:text-[#1086a4]"
          >
            <FaTimes className="w-5 h-5" />
          </button>
        </div>

        <div className="p-4 border-b border-[#1086a4]">
          <div className="relative">
            <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-[#1086a4] w-5 h-5" />
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search courses..."
              className="w-full pl-10 pr-4 py-2 text-gray-900 border border-[#1086a4] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1086a4]/20"
            />
          </div>
        </div>

        <div className="flex-1 overflow-y-auto p-4">
          {filteredCourses.length > 0 ? (
            <div className="space-y-2">
              {filteredCourses.map(course => (
                <div
                  key={course._id}
                  onClick={() => toggleCourse(course)}
                  className={`flex items-center p-3 rounded-lg border cursor-pointer ${
                    selectedCourses.includes(course)
                      ? 'border-[#1086a4] bg-[#1086a4]/5'
                      : 'border-gray-200 hover:border-[#1086a4]'
                  }`}
                >
                  <div className="flex-1">
                    <h3 className="font-medium text-[#054581]">{course.title}</h3>
                    <p className="text-xs text-gray-500 mt-1">
                      {(() => {
                        const lessonCount = course.lessonsCount ?? course.lessons?.length ?? 0;
                        const submissionFormCount = course.submissionFormsCount ?? course.submissionForms?.length ?? 0;
                        const parts = [];

                        if (lessonCount > 0) {
                          parts.push(`${lessonCount} ${lessonCount === 1 ? 'Lesson' : 'Lessons'}`);
                        }

                        if (submissionFormCount > 0) {
                          parts.push(`${submissionFormCount} ${submissionFormCount === 1 ? 'Mission' : 'Missions'}`);
                        }

                        return parts.length > 0 ? parts.join(' • ') : 'No content';
                      })()}
                    </p>
                  </div>
                  {selectedCourses.includes(course) && (
                    <FaCheck className="w-5 h-5 text-[#1086a4]" />
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center text-gray-500 py-8">
              No courses found matching your search.
            </div>
          )}
        </div>

        <div className="p-4 border-t border-[#1086a4] flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-[#1086a4] hover:text-[#054581]"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            disabled={!selectedCourses.length}
            className="px-4 py-2 bg-[#1086a4] text-white rounded-lg hover:bg-[#054581] disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Add Selected ({selectedCourses.length})
          </button>
        </div>
      </div>
    </div>
  );
};

export default CoursePickerModal; 